<template>
    <div v-if="componentLoader" class="position-relative h-100">
        <app-overlay-loader/>
    </div>
    <div v-else>
        <div class="form-group">
            <div class="row">
                <div class="col-lg-3 col-xl-3 d-flex align-items-center">
                    <label class="text-left d-block mb-lg-2 mb-xl-0">
                        {{ $t('name') }}
                    </label>
                </div>
                <div class="col-lg-8 col-xl-8">
                    <p class="mb-0 form-control-plaintext">{{ displayName || $t('not_available') }}</p>
                </div>
            </div>
        </div>
        <div class="form-group">
            <div class="row">
                <div class="col-lg-3 col-xl-3 d-flex align-items-center">
                    <label class="text-left d-block mb-lg-2 mb-xl-0">
                        {{ $t('email') }}
                    </label>
                </div>
                <div class="col-lg-8 col-xl-8">
                    <p class="mb-0 form-control-plaintext">{{ displayEmail || $t('not_available') }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {UserMixin} from "./Mixins/UserMixin";

    export default {
        name: "PersonalInformation",
        mixins: [UserMixin],
        computed: {
            displayName() {
                if (!this.user || !this.user.loggedInUser) {
                    console.log('PersonalInformation: No user data available');
                    return '';
                }
                console.log('PersonalInformation: User data:', this.user.loggedInUser);
                // Try different name fields
                const name = this.user.loggedInUser.name || 
                           this.user.loggedInUser.full_name || 
                           `${this.user.loggedInUser.first_name || ''} ${this.user.loggedInUser.last_name || ''}`.trim() || '';
                console.log('PersonalInformation: Resolved name:', name);
                return name;
            },
            displayEmail() {
                if (!this.user || !this.user.loggedInUser) {
                    return '';
                }
                const email = this.user.loggedInUser.email || '';
                console.log('PersonalInformation: Resolved email:', email);
                return email;
            }
        },
        watch: {
            'user.loggedInUser': {
                handler(newVal) {
                    console.log('PersonalInformation: User data changed:', newVal);
                },
                deep: true,
                immediate: true
            }
        },
        mounted() {
            console.log('PersonalInformation: Component mounted');
            console.log('PersonalInformation: Current user data:', this.user?.loggedInUser);
            // Ensure user data is loaded
            if (_.isEmpty(this.userInfo)) {
                console.log('PersonalInformation: User data empty, fetching...');
                this.$store.dispatch('getUser');
            } else {
                console.log('PersonalInformation: User data already available');
            }
        }
    }
</script>
